module.exports = __webpack_public_path__ + "static/media/BigBookScienceIcon.cbeba8f9.svg";